document.addEventListener('DOMContentLoaded', function() {
  const instagramSection = document.getElementById('instagram-follow-section');
  const instagramStatus = instagramSection.getAttribute('data-instagram-status');

  // Update the UI based on the stored status
  function updateUIStatus(status) {
    const hoverContent = instagramSection.querySelector('.hover-content');
    if (status === 'completed') {
      hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Wykonane</div>';
    } else {
      hoverContent.innerHTML = '<button class="follow-us-button" type="button">Obserwuj nas</button>';
    }
  }

  // Check status on page load
  updateUIStatus(instagramStatus);

  // Handle the follow button click
  instagramSection.addEventListener('click', async function(event) {
    if (event.target.classList.contains('follow-us-button')) {
      event.preventDefault();
      const customerId = instagramSection.getAttribute('data-customer-id');
      const hoverContent = instagramSection.querySelector('.hover-content');

      console.log('Submitting Instagram Follow for Customer ID:', customerId);

      // Show loading message
      hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Czekaj...</div>';

      try {
        // Call Cloud Function to submit follow request
        const response = await fetch('https://us-central1-la-roue-53165.cloudfunctions.net/followInstagramFunction', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ customerId: customerId, points: 50 })
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();

        if (result.success) {
          // Open Instagram in a new tab
          window.open('https://www.instagram.com/larouebrand/', '_blank');

          // Update the Instagram metafield to mark as completed
          await fetch('/updateCustomerMetafield', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              customerId: customerId,
              metafield: {
                namespace: 'custom',
                key: 'instagram',
                value: 'completed',
                type: 'single_line_text_field'
              }
            })
          });

          // Update UI to completed state with success message
          hoverContent.innerHTML = '<div class="status-completed"><span class="check-icon">&#10003;</span> Dziękujemy za obserwowanie</div>';
          // Update the data attribute to reflect the completed status
          instagramSection.setAttribute('data-instagram-status', 'completed');
        } else {
          throw new Error('Failed to submit Instagram follow');
        }
      } catch (error) {
        console.error('Error:', error);
        // Show error message
        hoverContent.innerHTML = '<button class="follow-us-button" type="button">Obserwuj nas</button>';
        alert('Error: ' + error.message);
      }
    }
  });
});

